import { Play } from 'lucide-react';
import type React from 'react';

type PlayOverlayProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

/**
 * A standalone play overlay button for covers.
 * Border-only white circle with semi-transparent black fill and a white play icon.
 * Non-interactive (pointer-events: none) so it doesn't block parent click handlers.
 */
const PlayOverlay: React.FC<PlayOverlayProps> = ({ size = 'md', className }) => {
  const px = size === 'sm' ? 28 : size === 'lg' ? 48 : 36;
  const icon = size === 'sm' ? 14 : size === 'lg' ? 20 : 16;

  return (
    <div
      aria-hidden="true"
      style={{ pointerEvents: 'none' }}
      className={`${className || ''} absolute inset-0 flex items-center justify-center z-10`}
    >
      <div
        style={{ width: px, height: px }}
        className="rounded-full bg-black/35 flex items-center justify-center shadow-lg"
      >
        <Play size={icon} color="#ffffff" fill="#ffffff" className="ml-0.5" />
      </div>
    </div>
  );
};

export default PlayOverlay;



